import { render } from "./AppInputTel.vue?vue&type=template&id=6f1b0b06"
import script from "./AppInputTel.vue?vue&type=script&lang=ts"
export * from "./AppInputTel.vue?vue&type=script&lang=ts"
script.render = render

export default script